// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ATek-","checkboxCol":"Table_checkboxCol__35sAO","emailCol":"Table_emailCol__32e-4","actionCol":"Table_actionCol__1Tdbi"};